import { render, staticRenderFns } from "./LogoAnchor.vue?vue&type=template&id=0784550b&"
import script from "./LogoAnchor.vue?vue&type=script&lang=ts&"
export * from "./LogoAnchor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports